"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */function (_super) {
  __extends(SentryError, _super);
  function SentryError(message) {
    var _newTarget = this.constructor;
    var _this = _super.call(this, message) || this;
    _this.message = message;
    // tslint:disable:no-unsafe-any
    _this.name = _newTarget.prototype.constructor.name;
    Object.setPrototypeOf(_this, _newTarget.prototype);
    return _this;
  }
  return SentryError;
}(Error);
exports.SentryError = SentryError;